var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_vm._v("\n  Diese Funktion wurde noch nicht entwickelt\n")])}
var staticRenderFns = []

export { render, staticRenderFns }